module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fc-Gb-Hb-Ia.a8f3862e.png";